module.exports = __webpack_public_path__ + "img/11.9.TU.cbb2d927.png";